import { TMSScanOrderConfig } from "@/types";
import { Descriptions, Switch } from "antd";
import { useMemo } from "react";
import { DescriptionsItemProps } from "antd/es/descriptions/Item";
import { PalletScanLabelConfig } from "./helper";

interface PalletScanConfigProps {
  scanConfig: TMSScanOrderConfig;
  extraConfig: PalletScanLabelConfig;
  changeExtraConfig: (
    key: keyof PalletScanLabelConfig,
    value: boolean | string,
  ) => void;
}

export default function PalletScanConfig(props: PalletScanConfigProps) {
  const { scanConfig, extraConfig, changeExtraConfig } = props;
  const infoItems = useMemo(() => {
    const items: DescriptionsItemProps[] = [];
    items.push(
      ...[
        {
          label: "Has Carton Label",
          children: (
            <Switch
              checkedChildren="Yes"
              unCheckedChildren="No"
              checked={scanConfig.hasCartonLabel}
            />
          ),
        },
        {
          label: "Has Shipping Label",
          children: scanConfig.shippingLabelMode,
        },
        {
          label: "Scan Mode",
          children: (
            <Switch
              checkedChildren="Auto"
              unCheckedChildren="Manual"
              disabled={!scanConfig.hasCartonLabel}
              checked={extraConfig.scanMode === "auto"}
              onChange={(checked) => {
                changeExtraConfig("scanMode", checked ? "auto" : "manual");
              }}
            />
          ),
        },
      ],
    );
    if (scanConfig.hasCartonLabel) {
      items.push({
        label: "Print Carton Label",
        children: (
          <Switch
            checkedChildren="Auto"
            unCheckedChildren="Manual"
            disabled={!scanConfig.hasCartonLabel}
            checked={extraConfig.autoPrintCartonLabel}
            onChange={(checked) => {
              changeExtraConfig("autoPrintCartonLabel", checked);
            }}
          />
        ),
      });
    }
    items.push({
      label: "Print Pallet Label",
      children: (
        <Switch
          checkedChildren="Yes"
          unCheckedChildren="No"
          checked={extraConfig.autoPrintPalletLabel}
          onChange={(checked) => {
            changeExtraConfig("autoPrintPalletLabel", checked);
          }}
        />
      ),
    });
    return items;
  }, [scanConfig, extraConfig, changeExtraConfig]);

  return (
    <Descriptions
      column={3}
      size="small"
      bordered
      items={infoItems}
      styles={{
        label: { width: "15%" },
        content: { width: "15%" },
      }}
    />
  );
}
